// Deliberately the leaf module rather than the `./i18n` barrel: that barrel
// reaches `@heidi/schema/ml-scribe` for the dictation-language map, and only the
// locale mapping is needed here. This module is not re-exported from the package
// root for the same reason — subpath door only, `@heidi/utils/help-center`.
import { toIntercomHelpCenterLocale } from './i18n/to-intercom-help-center-locale';

export const HELP_CENTER_BASE = 'https://support.heidihealth.com';

/**
 * Builds a localised help center home URL.
 */
export const getHelpCenterHomeUrl = (locale?: string): string => {
  const intercomLocale = toIntercomHelpCenterLocale(locale);
  return `${HELP_CENTER_BASE}/${intercomLocale}/`;
};

/**
 * Builds a localised help center URL.
 *
 * @param path - Article or collection path *without* the locale prefix,
 *               e.g. `'articles/8974419-what-is-context'`
 * @param locale - App locale such as `'de-DE'` or `'fr'`. Resolved via
 *                 {@link toIntercomHelpCenterLocale}; unsupported values fall
 *                 back to `en`.
 */
export const getHelpCenterUrl = (path: string, locale?: string): string => {
  const intercomLocale = toIntercomHelpCenterLocale(locale);
  const normalizedPath = path.replace(/^\//, '');
  return `${HELP_CENTER_BASE}/${intercomLocale}/${normalizedPath}`;
};
